import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { Link } from 'react-router-dom';
import Label from 'reactstrap/lib/Label';
import { TR } from 'src/TextRes';
import { BookingOption, CoursesListAppointmentLine, CoursesListLoadMineLine } from '../../api';
import { ISortIcon } from '../../constants';
import FAIcon from '../fAIcon/FAIcon';
import { IThConfig, SortableTh } from '../sortableTh/SortableTh';
import { TableBox } from '../tableBox/TableBox';
import './CPCoursesTableBox.css';

interface IState {
    showMore: boolean[];
}

export interface TableBoxWithCollapseIconProps<T> {
    listData?: T[];
    renderTHeadLine: IThConfig[];
    headerStyle?: string;
    sortIcon: ISortIcon[];
    collapsed: boolean;
    onClickSorting: (sortField: string, index: number, sortIcon: ISortIcon) => void;
    onDelete: (courseId: string) => void;
}

export default class CPCoursesTableBox extends React.PureComponent<
    TableBoxWithCollapseIconProps<CoursesListLoadMineLine>,
    IState
> {
    constructor(props: TableBoxWithCollapseIconProps<CoursesListLoadMineLine>) {
        super(props);
        this.state = {
            showMore: [],
        };
    }

    public componentDidMount() {
        const showMoreArray: boolean[] = [];
        if (this.props.listData) {
            this.props.listData.map(() => {
                showMoreArray.push(false);
            });
            this.setState({
                showMore: [...showMoreArray],
            });
        }
    }

    public render() {
        if (!this.props.listData) {
            return null;
        }
        const noResultsMessage = TR.cPCoursesTableBox_no_results;

        if (this.props.listData.length < 1) {
            return (
                <legend className="my-3" style={{ color: 'red' }}>
                    {noResultsMessage}
                </legend>
            );
        }

        const renderTHeadLine = (
            <tr className={'courseTableBoxHeader'}>
                {this.props.renderTHeadLine.map((str: IThConfig, index: number) => {
                    return (
                        <SortableTh
                            key={str.name + index}
                            index={index}
                            sortIcon={this.props.sortIcon[index]}
                            sortField={str.sortField}
                            onClickSorting={this.props.onClickSorting}
                            widthStyle={str.width}
                            name={str.name}
                        />
                    );
                })}
            </tr>
        );

        return (
            <TableBox
                listData={this.props.listData}
                renderTBodyLine={this.renderTBody}
                renderTHeadLine={renderTHeadLine}
                headerStyle={this.props.headerStyle}
                bordered={false}
            />
        );
    }

    private renderTBody = (lineData: CoursesListLoadMineLine, index: number) => {
        const translations = {
            continuous: 'Fortlaufender Kurs',
            ondemand: 'Kurs auf Anfrage',
            selflearn: 'Selbstlernkurs',
            set: 'Kurs mit Terminsets',
            single: 'Kurs mit Einzelterminen',
        };

        const courseRow = (
            <tr className="titleRow">
                <td>
                    <a href={'#/cpcoursedetail/' + lineData.CourseID} className={'courseTitle'}>
                        {lineData.Title}
                    </a>
                    <br />

                    {
                        // @ts-ignore
                        translations[lineData.Type]
                    }
                </td>
                <td>{lineData.Lecturer}</td>
                <td>
                    {lineData.Published ? (
                        <FAIcon mouseHover={TR.cPCoursesTableBox_published_course} icon="circle" />
                    ) : (
                        <FAIcon mouseHover={TR.cPCoursesTableBox_not_published} icon="circle" className="circleend" />
                    )}
                    &nbsp;
                    {lineData.Disabled && (
                        <FAIcon
                            mouseHover={TR.cPCoursesTableBox_course_blocked_by_admin}
                            icon="ban"
                            className="banned"
                        />
                    )}
                </td>
                <td>
                    <a
                        onClick={() => {
                            this.props.onDelete(lineData.CourseID);
                        }}
                    >
                        <FAIcon icon="trash" />
                    </a>
                </td>
                <td>
                    <a href={'#/cpcoursedetail/' + lineData.CourseID}>
                        <FAIcon icon="edit" />
                    </a>
                </td>
            </tr>
        );

        let appointments: CoursesListAppointmentLine[] = lineData.Appointments;
        if (this.props.collapsed && appointments) {
            appointments = appointments.filter((a: CoursesListAppointmentLine, i: number) =>
                moment(a.Appointment.StartDate).isAfter(moment())
            );
        }

        let bookingCount = 0;

        if (appointments) {
            // appointments = appointments.sort((a: CoursesListAppointmentLine, b: CoursesListAppointmentLine) => {
            //     const after = moment(a.Appointment.StartDate).isAfter(moment(b.Appointment.StartDate));
            //     return after ? -1 : 1;
            // });

            appointments.map((line: CoursesListAppointmentLine) => {
                bookingCount += line.Bookings;
            });
        }

        let detailsRow = null;
        detailsRow = (
            <>
                <tr className="detailsRow">
                    <td colSpan={5}>
                        {appointments && appointments.length > 0 && (
                            <div>
                                {appointments && appointments.length > 1 && (
                                    <a
                                        onClick={() => {
                                            const showMoreN: boolean[] = this.state.showMore;
                                            showMoreN[index] = !showMoreN[index];
                                            this.setState((prevState: IState) => {
                                                return { ...prevState, showMore: [...showMoreN] };
                                            });
                                        }}
                                        className="collapseLink pull-left"
                                    >
                                        {this.state.showMore[index] ? (
                                            <FAIcon mouseHover="Weniger anzeigen" icon="minus-circle" />
                                        ) : (
                                            <FAIcon mouseHover="Mehr anzeigen" icon="plus-circle" />
                                        )}
                                    </a>
                                )}
                                &nbsp;&nbsp;
                                <Label>
                                    {TR.cPCoursesTableBox_appointments}{' '}
                                    {bookingCount > 0 && appointments.length > 1 && !this.state.showMore[index]
                                        ? '(' +
                                          bookingCount +
                                          (bookingCount === 1
                                              ? TR.cPCoursesTableBox_request
                                              : TR.cPCoursesTableBox_requests)
                                        : ''}
                                </Label>
                                {(appointments.length === 1 || this.state.showMore[index]) && (
                                    <table className="cpcoursedetailtable mb-2">
                                        <thead>
                                            <tr>
                                                <td>{TR.cPCoursesTableBox_start_date}</td>
                                                <td>{TR.cPCoursesTableBox_end_date}</td>
                                                <td>{TR.cPCoursesTableBox_number_places}</td>
                                                <td>{TR.cPCoursesTableBox_booking_requests}</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {appointments.map((line: CoursesListAppointmentLine, i) => {
                                                const startDate = moment(line.Appointment.StartDate);
                                                const over = startDate.isBefore(moment());
                                                return (
                                                    <tr key={i} className={over ? 'over' : ''}>
                                                        <td>{startDate.format('DD.MM.YYYY')}</td>
                                                        <td>{moment(line.Appointment.EndDate).format('DD.MM.YYYY')}</td>
                                                        <td>{line.Appointment.MaxParticipants}</td>
                                                        <td>
                                                            {line.Bookings > 0 && (
                                                                <Link to={'/cpbookings/' + startDate.format('YYYY-MM')}>
                                                                    {line.Bookings}
                                                                </Link>
                                                            )}
                                                            {line.Bookings === 0 && '0'}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        )}
                        <p>
                            {' '}
                            {TR.cPCoursesTableBox_booking_options}{' '}
                            {lineData.BookingOptions.map((line: BookingOption, i: number) => {
                                const comma = i === 0 ? '' : ', ';
                                return comma + line.Name + ': ' + line.Price + ' €';
                            })}
                        </p>
                    </td>
                </tr>
                <tr className="separatorRow">
                    <td colSpan={5}>&nbsp; </td>
                </tr>
            </>
        );

        return (
            <React.Fragment key={index + lineData.CourseID + lineData.Lecturer}>
                {courseRow}
                {detailsRow}
            </React.Fragment>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpCoursesTableBox/CPCoursesTableBox.tsx